import { timeSheetDetailsRoutes } from './features/time-sheet-details/time-sheet-details.routes';
import { timeSheetsListingRoutes } from './features/time-sheets-listing/time-sheets-listing.routes';

export const timeSheetsRoutes = [
  {
    path: '/time-sheets',
    name: 'time-sheets',
    meta: {
      requiresAuth: true // all app paths requires authentication
    },
    component: () => import(/* webpackChunkName: "time-sheets" */ './TimeSheets.vue'),
    children: [
      {
        path: 'batch-update',
        name: 'time-sheet-batch-update',
        component: () =>
          import(/* webpackChunkName: "time-sheet-batch-update" */ '../../features/batch-update/BatchUpdateListing.vue')
      },
      ...timeSheetsListingRoutes,
      ...timeSheetDetailsRoutes
    ]
  }
];
